import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import copy from 'copy-to-clipboard';
import { Variant } from '../../Constants/System';
import Icon from './Icon';
import Button from '../Interactive/Button/Button';
export default function Codeblock(props) {
    const { text, onCopyToClipboard } = props;
    const handleCopyToClipboard = () => {
        if (text) {
            const didCopy = copy(text);
            onCopyToClipboard?.(didCopy);
        }
    };
    return (_jsxs(StyledCodeblock, { className: props.className, children: [_jsx(Scroller, { children: _jsx(StyledCode, { children: text }) }), _jsx(CopyToClipboardButton, { onClick: handleCopyToClipboard, title: "Copy to clipboard", variant: Variant.quiet, children: _jsx(Icon, { name: "copy" }) })] }));
}
const Scroller = styled.div `
	overflow-x: auto;
	padding: ${({ theme }) => theme.spacing.lg};
	${(props) => props.theme.scrollbars.skinny}
`;
const StyledCode = styled.code `
	font-size: ${(props) => props.theme.typography.sm};
`;
const CopyToClipboardButton = styled(Button) `
	margin: 0 0 0 auto;
	display: block;

	position: absolute;
	right: 0;
	top: 0;
`;
const StyledCodeblock = styled.pre `
	background: ${({ theme }) => theme.palette.shade7};
	position: relative;
`;
//# sourceMappingURL=Codeblock.js.map